'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get2 = require('babel-runtime/helpers/get');

var _get3 = _interopRequireDefault(_get2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _desc, _value, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ClientSideComponent = require('core/ClientSideComponent');

var _ClientSideComponent2 = _interopRequireDefault(_ClientSideComponent);

var _components = require('components');

var _autobindDecorator = require('autobind-decorator');

var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var CropUploader = (_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(CropUploader, _Component);

  function CropUploader() {
    var _ref;

    (0, _classCallCheck3.default)(this, CropUploader);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var _this = (0, _possibleConstructorReturn3.default)(this, (_ref = CropUploader.__proto__ || (0, _getPrototypeOf2.default)(CropUploader)).call.apply(_ref, [this].concat(args)));

    _this._uploaderOnComplete = function (id, name, response) {
      var onUpload = _this.props.onUpload;

      _this.cropper.getWrappedInstance().destroy();
      if (onUpload) {
        onUpload(id, name, response);
      }
    };

    _this.state = { loading: false };
    return _this;
  }

  (0, _createClass3.default)(CropUploader, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      (0, _get3.default)(CropUploader.prototype.__proto__ || (0, _getPrototypeOf2.default)(CropUploader.prototype), 'componentDidMount', this).call(this, this._mountUploader);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      (0, _get3.default)(CropUploader.prototype.__proto__ || (0, _getPrototypeOf2.default)(CropUploader.prototype), 'componentWillUnmount', this).call(this, this._unMountUploader);
    }
  }, {
    key: 'onImageSelected',
    value: function onImageSelected(e) {
      this.cropper.getWrappedInstance().onImageSelected(e);
    }
  }, {
    key: '_mountUploader',
    value: function _mountUploader() {
      var FineUploaderTraditional = require('components/FineUploader/traditional');
      var uploaderParams = this.props.uploaderParams;


      this.uploader = new FineUploaderTraditional({
        request: { params: uploaderParams.queryParams },
        chunking: { success: { endpoint: uploaderParams.endpoint } }
      });
      this.uploader.on('complete', this._uploaderOnComplete);
    }
  }, {
    key: '_unMountUploader',
    value: function _unMountUploader() {
      this.uploader.off('complete', this._uploaderOnComplete);
      this.uploader.methods.cancelAll();
      this.uploader = null;
    }
  }, {
    key: '_onCrop',
    value: function _onCrop(originalFile, cropped, fileName, cropper) {
      var _props = this.props,
          uploadCropped = _props.uploadCropped,
          uploaderParams = _props.uploaderParams;


      if (uploadCropped) {
        this.uploader.methods.addFiles([{ canvas: cropped, name: fileName, quality: 80, type: 'image/jpeg' }]);
      } else {
        var cropData = cropper.getData(true);
        var x1 = cropData.x;
        var x2 = cropData.x + cropData.width;
        var y1 = cropData.y;
        var y2 = cropData.y + cropData.height;
        this.uploader.methods.setParams((0, _extends3.default)({ x1: x1, x2: x2, y1: y1, y2: y2 }, uploaderParams.queryParams));
        this.uploader.methods.addFiles(originalFile);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var isMounted = this.state.isMounted;
      var _props2 = this.props,
          uploaderParams = _props2.uploaderParams,
          onUpload = _props2.onUpload,
          cropperProps = (0, _objectWithoutProperties3.default)(_props2, ['uploaderParams', 'onUpload']); // eslint-disable-line no-unused-vars

      return _react2.default.createElement(
        'div',
        null,
        isMounted && _react2.default.createElement(_components.Cropper, (0, _extends3.default)({ ref: function ref(el) {
            return _this2.cropper = el;
          } }, cropperProps, { onCrop: this._onCrop }))
      );
    }
  }]);
  return CropUploader;
}(_ClientSideComponent2.default), _class2.propTypes = {
  className: _propTypes2.default.string,
  onUpload: _propTypes2.default.func,
  uploadCropped: _propTypes2.default.bool,
  uploaderParams: _propTypes2.default.object.isRequired
}, _temp), (_applyDecoratedDescriptor(_class.prototype, '_mountUploader', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, '_mountUploader'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, '_unMountUploader', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, '_unMountUploader'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, '_onCrop', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, '_onCrop'), _class.prototype)), _class);
exports.default = CropUploader;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Cropper/CropUploader.js
// module id = 1981
// module chunks = 1